import { BCMSStateManagerCRUD, BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import Classes from "model";
import EDEStatementsEnrollmentAgreementPage, { getDefaultPageData, getDefaultPageUI } from "components/EDEStatements/pages/EDEStatementsEnrollmentAgreementPage";

/**
 * @name CaptureEDEStatementsEnrollmentAgreementCodeEntered
 * @returns {React.Component}
 * @description A capture in the "EDE eStatement Enrollment" capture group.
 */
export default function CaptureEDEStatementsEnrollmentAgreementCodeEntered(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
    .update([ "confirmationCode", "value" ], "GNB74")
    .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    .update([ "scrollBar", "isActive" ], true)
    .submit();

    return <EDEStatementsEnrollmentAgreementPage data={ data } ui={ ui } />;
}